<template>
  <div class="ads-table-container">
    <div class="new-ad">
      <a class="button cta small" href="/#/ads/new">CREATE NEW AD</a>
    </div>
    <table v-if="!isMobile">
      <thead>
        <tr class="table-header">
          <th>ID</th>
          <th>BRAND</th>
          <th>TYPE</th>
          <th>TITLE</th>
          <th>DESCRIPTION</th>
          <th>START DATE</th>
          <th>END DATE</th>
          <th>PUBLISHED</th>
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        <tr class="ad-item" v-for="(item, index) in items">
          <td>{{ item.ID }}</td>
          <td>{{ item.brandId }}</td>
          <td><span v-bind:class="['ad-type', item.type]">{{ item.type }}</span></td>
          <td>{{ item.tooltipTitle }}</td>
          <td>{{ item.tooltipDescription }}</td>
          <td>{{ item.startDateStr }}</td>
          <td>{{ item.endDateStr }}</td>
          <td>{{ item.published ? 'YES' : 'NO' }}</td>
          <td>
            <a class="button cta xsmall" :href="'/#/ads/' + item.ID">EDIT</a>
            <a v-bind:class="{'button cta warning xsmall': true, disabled: item.saving }"
               href="javascript:;" v-if="item.published" @click="publish(item, index)">UNPUBLISH</a>
            <a v-bind:class="{'button cta success xsmall': true, disabled: item.saving }"
               href="javascript:;" v-else @click="publish(item, index)">PUBLISH</a>
            <a v-bind:class="{'button cta error xsmall': true, disabled: item.deleting }"
               href="javascript:;" @click="remove(item, index)">DELETE</a>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <div class="loader" v-show="isLoading">
        <div class="v-center">
          <i class="fa fa-spinner fa-spin fa-fw fa-2x"></i>Loading...
        </div>
      </div>
      <div class="cards" v-for="(item, index) in items" :key="index">
        <div class="card">
          <div class="card-header">
            <div class="header">
              <span class="label">ID: </span>
              <div class="value">{{item.ID}}</div>
              <span class="label">Brand:</span>
              <div class="value">{{item.brandId}}</div>
              <span v-bind:class="['ad-type', item.type]">{{ item.type }}</span>
              
            </div>
            <div class="header">
              <span class="label">Published: </span>
              <div class="value">{{ item.published ? 'YES' : 'NO' }}</div>
            </div>
          </div>
          <div class="title">
            <span class="label">Title: </span>
            <div class="value">{{ item.tooltipTitle }}</div>
          </div>
          <div class="title">
            <span class="label">Description: </span>
            <div class="value">
              {{ item.tooltipDescription }}
            </div>
          </div>
          <div class="title">
            <span class="label">Start Date: </span>
            <div class="value">{{ item.startDateStr }}</div>
          </div>
          <div class="title">
            <span class="label">End Date: </span>
            <div class="value">{{ item.endDateStr }}</div>
          </div>
          <div class="actions">
            <a class="button cta xsmall" :href="'/#/ads/' + item.ID">EDIT</a>
            <a v-bind:class="{'button cta warning xsmall': true, disabled: item.saving }"
               href="javascript:;" v-if="item.published" @click="publish(item, index)">UNPUBLISH</a>
            <a v-bind:class="{'button cta success xsmall': true, disabled: item.saving }"
               href="javascript:;" v-else @click="publish(item, index)">PUBLISH</a>
            <a v-bind:class="{'button cta error xsmall': true, disabled: item.deleting }"
               href="javascript:;" @click="remove(item, index)">DELETE</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ads-table',
  data () {
    return {
      items: [],
      isMobile: false,
      isLoading: false
    }
  },
  methods: {
    getAds () {
      let self = this
      self.isLoading = true
      self.items = []
      self.$sdk.get('/ads', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.isLoading = false
        if (r.error) {
          // show error
          return
        }
        for (let i = 0; i < r.list.length; i++) {
          self.items.push(self.formatAd(r.list[i]))
        }
      })
    },
    formatAd (data) {
      let isMilitaryTime = this.$settings.get('MilitaryTime') === '1'
      let start = data.startDate.substr(0, 10) + ' 00:01 AM'
      let end = data.endDate.substr(0, 10) + ' 11:59 PM'
      if (isMilitaryTime) {
        start = data.startDate.substr(0, 10) + ' 00:01'
        end = data.endDate.substr(0, 10) + ' 23:59'
      }

      data.startDateStr = start
      data.endDateStr = end
      data.saving = false
      data.deleting = false
      return data
    },
    publish (ad, index) {
      let self = this
      ad.token = self.$store.state.session.sessionToken
      ad.saving = true
      if (ad.published === 1) {
        ad.published = 0
      } else {
        ad.published = 1
      }
      self.$sdk.post('/ads/' + ad.ID, ad, r => {
        ad.saving = false
        if (r.error) {
          return
        }
      })
    },
    remove (ad, index) {
      let self = this
      ad.deleting = true
      self.$sdk.delete('/ads/' + ad.ID, {
        token: self.$store.state.session.sessionToken
      }, r => {
        console.log(r)
        ad.deleting = false
        if (r.error) {
          return
        }
        self.items.splice(index, 1)
      })
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.documentElement.clientWidth < 431){
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  mounted () {
    this.getAds()
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>

table{
  border-collapse: collapse;
  width: 100%;

  & thead{
  }
}
.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th{
    padding: 5px;
  }
}

.ads-table-container {
  padding: 20px;
}

.ad-item{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);

  & td{
    padding: 10px 5px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;
  }

  & .ad-type{
    display: inline-block;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    padding: 3px 5px;
    border-radius: 3px;
    background-color: #333;

    &.provider { background-color: #333; }
    &.consumer { background-color: #26D97A; }
    &.web { background-color: #F25E0D; }
  }
}

.new-ad{
  margin-bottom: 20px;
  text-align: right;
}

.loader{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .7);
  color: #fff;

  i{
    vertical-align: middle;
    margin-right: 5px;
  }
  .v-center{
    text-align: center;
    width: 100%;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
}

@media only screen and (max-width: 430px) {
  .new-ad {
    text-align: center;
  }
  .card-holder {
    margin-top: 15px;
    padding-bottom: 40px;
  }
  .cards {
    .card {
      border: 1px solid #ccc;
      margin: 0 10px;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;
      font-size: 12px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 3px;
        border-bottom: 1px solid #eee;
        .name {
          font-weight: 900;
        }
        .ad-type{
          display: inline-block;
          text-transform: uppercase;
          font-size: 10px;
          font-weight: 700;
          color: #fff;
          padding: 3px 5px;
          border-radius: 3px;
          background-color: #333;

          &.provider { background-color: #333; }
          &.consumer { background-color: #26D97A; }
          &.web { background-color: #F25E0D; }
        }
        .header {
          display: flex;
        }
        
      }

      .title {
        display: flex;
        align-items: center;
      }

      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-weight: 500;
        text-align: left;
      }

      .actions {
        border-top: 1px solid #eee;
        padding-top: 10px;
        padding-bottom: 5px;
        margin-top: 10px;
        text-align: right;
        display: flex;
        justify-content: space-between;
        gap: 10px;

        .button {
          flex: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingAds/AdsTable.vue